import axios from "./CustomAxios"
import uaxios from 'axios'
import { accountUrl, adminUrl, ApiBaseURL, appUrl, configURL } from "../Assets/Urls/Urls"

export const VenueByPincode = async (pincode) => {
    const url = `${ApiBaseURL}${appUrl.getVenueByFilter}${pincode}`
    const response = await uaxios.get(url)
    return response
}

export const otpSender = async (contactNo) => {
    try {
        const url = `${ApiBaseURL}${configURL.otpSender}`
        const response = await uaxios.post(url, {
            phone: contactNo
        })
        return response
    } catch (error) {
        console.log('Error getting response', error)
    }
}

export const Banners = async () => {
    try {
        const url = `${ApiBaseURL}${appUrl.getBanners}`
        const response = await uaxios.get(url)
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const Promotions = async () => {
    try {
        const url = `${ApiBaseURL}${appUrl.getPromotions}`
        const response = await uaxios.get(url)
        return response
    } catch (error) {
        console.log('Error getting response', error)
    }
}

export const getNearByVenuesApi = async (pincode) => {
    try {
        const url = `${ApiBaseURL}${appUrl.getVenueByFilter}?pincode=${pincode}`
        const response = uaxios.get(url)
        return response
    } catch (error) {
        console.log('Error', error)
    }
}

export const getVenueDetailsApi = async (venueId) => {
    try {
        const url = `${ApiBaseURL}${appUrl.getVenueDetails}${venueId}/`
        const response = await uaxios.get(url)
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const getSportsApi = async () => {
    try {
        const url = `${ApiBaseURL}${appUrl.getSports}`
        const response = await uaxios.get(url)
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const getAllPincodeApi = async (params) => {
    try {
        const url = `${ApiBaseURL}${appUrl.getPincode}`
        const response = await uaxios.get(url, { params: params })
        return response
    } catch (error) {
        console.log('Error', error)
    }
}

export const pincodeVenue = async (pincode) => {
    const query = { pin_code: pincode }
    try {
        const url = `${ApiBaseURL}${appUrl.getNearByVenues}`
        const response = await uaxios.get(url, { params: query })
        return response
    } catch (error) {
        console.log('Error', error)
    }
}

export const getAllHomeVenues = async (params) => {
    try {
        const url = `${ApiBaseURL}${appUrl.getAllHomeVenues}`
        const response = await uaxios.get(url, { params: params })
        return response
    } catch (error) {
        console.log('Error getting all home venues:', error)
        return { data: { status: 'error', data: [] } }
    }
}

export const getUiDetails = async () => {
    try {
        const url = `${ApiBaseURL}${configURL.getUiDetails}`
        const response = await uaxios.get(url)
        return response
    } catch (error) {
        console.log('Error getting UI details:', error)
        return {
            data: {
                status: 'success',
                data: {
                    color: '#f97316',
                    home_sections: {
                        banner: true,
                        promotion: true,
                        upcoming_event: false,
                        nearby_venue: true
                    },
                    show_maintenance_notice: false,
                    maintenance_message: ''
                }
            }
        }
    }
}

export const getSlots = async (data) => {
    try {
        const url = `${ApiBaseURL}${appUrl.getVenueSlots}`
        const response = await uaxios.post(url, data)
        return response
    } catch (error) {
        console.log('Error', error)
    }
}

export const bookCourt = async (data) => {
    try {
        const url = `${ApiBaseURL}${appUrl.bookSlot}`
        const response = await axios.post(url, data)
        return response
    } catch (error) {
        console.log('Error', error)
    }
}

export const LoginAPI = async (data) => {
    try {
        const url = `${ApiBaseURL}${accountUrl.loginUrl}`
        const reponse = await uaxios.post(url, data)
        return reponse
    } catch (error) {
        console.log('error', error)
        return error
    }
}

export const partialBookingCourtPayment = async (payload) => {
    try {
        const url = `${ApiBaseURL}${appUrl.partialPaymentUrl}`;
        const response = await axios.post(url, payload)
        return response.data
    }
    catch (error) {
        console.log("error : ", error);
    }
}

export const paymentOrderId = async data => {
    const paymentOrderIdURL = `${ApiBaseURL}${configURL.generateOrderIdUrl}`;
    try {
        const paymentOrderIdResponse = await axios.post(paymentOrderIdURL, data);
        return paymentOrderIdResponse.data.data;
    } catch (error) {
        console.log("error api file========", error);
    }
}

export const normalCourtPayment = async (payload) => {
    try {
        const url = `${ApiBaseURL}${appUrl.normalBookingUrl}`;
        const response = await axios.post(url, payload)
        return response.data
    }
    catch (error) {
        console.log("error : ", error);
    }
}

export const splitPaymentCourtPayment = async (payload) => {
    try {
        const url = `${ApiBaseURL}${appUrl.splitCourtPaymrntUrl}`;
        const response = await axios.post(url, payload)
        return response.data
    }
    catch (error) {
        console.log("error : ", error);
    }
}


export const EditUserProfile = async (data, id) => {
    try {
        const url = `${ApiBaseURL}${accountUrl.editprofileUrl}${id}/`
        const response = await axios.put(url, data)
        return response;

    } catch (error) {
        console.log('error', error)
    }
}

export const getBookingDetails = async (bookingId) => {
    try {
        const url = `${ApiBaseURL}${adminUrl.bookingDetailsUrl}${bookingId}`
        const response = await axios.get(url)
        return response.data
    } catch (error) {
        console.log('Error', error)
    }
}

export const getBookingsList = async (filterData) => {
    const filterPayload = {
        "page": filterData?.page || 1,
        "page_size": 10,
        "user": filterData?.user
    }
    try {
        const url = `${ApiBaseURL}${adminUrl.userBookingDetailsUrl}`;
        const response = await axios.get(url, { params: filterPayload })
        return response.data
    }
    catch (error) {
        console.log("error : ", error);
    }
}

export const getBookingDetailsByQuery = async (bookingId) => {
    try {
        const url = `${ApiBaseURL}${adminUrl.userBookingDetailsFilterByIdUrl}`;
        const response = await axios.get(url, { params: { booking_id: bookingId } });
        return response.data;
    } catch (error) {
        console.log('Error', error);
        throw error;
    }
};

export const courtVenueSportFilter = async (payload) => {
    const url = `${ApiBaseURL}${adminUrl.filterCourtUrl}`;
    try {
        const response = await axios.post(url, payload)
        return response.data
    }
    catch (err) {
        console.log(err);
        throw err?.response?.data
    }
}

export const UserRegistrationApi = async (data) => {
    try {
        const url = `${ApiBaseURL}${accountUrl.registrationUrl}`
        const response = await uaxios.post(url, data)
        return response.data
    } catch (error) {
        console.log('Error', error)
    }
}

export const getVenueDetailsNonSecure = async (id) => {
    try {
      const url = `${ApiBaseURL}${appUrl.getVenueDetails}${id}/`;
      const response = await uaxios.get(url)
      return response.data
    }
    catch (error) {
      console.log("error api file========", error);
    }
  };


export const getVenueDetails = async (venueId) => {
    try {
        const url = `${ApiBaseURL}${configURL.VenueDetails}${venueId}/`;
        const response = await axios.get(url)
        return response.data
    }
    catch (err) {
        console.log(err);
    }
};


export const getAddOnsDetailsApi = async (sport_venue_id) => {
    try {
        const url = `${ApiBaseURL}${appUrl.AddonsURL}${sport_venue_id}/`
        const response = await axios.get(url)
        return response?.data
    } catch (error) {
        console.log('error', error)
    }
}

export const AddRatingApi = async (data) => {
    try {
        const url = `${ApiBaseURL}${appUrl.AddRating}`
        const response = await axios.post(url, data)
        return response?.data
    } catch (error) {
        console.log('error', error)
    }
}

export const getCalculatedSlotPrice = async (pricePayload) => {
    const url = `${ApiBaseURL}${configURL?.slotPriceExtractor}`;
  
    // Required fields for validation
    const requiredFields = [
        "venue",
        "sport",
        "court",
        "start_time",
        "end_time",
        "weekday",
        "specific_date"
    ];  
  
    try {
        // Validate payload
        const missingFields = requiredFields.filter(
            (field) => !(field in pricePayload) || pricePayload[field] === null || pricePayload[field] === ""
        );
  
        if (missingFields.length > 0) {
            throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
        }
  
        // Make the API call
        const response = await axios.post(url, pricePayload);
        return response.data;
    } catch (err) {
        console.error(err.message || err);
        throw err?.response?.data || err?.message || err;
    }
  };

  export const getAddonsFromSport = async (venueId, sportId) => {
    const url = `${ApiBaseURL}${adminUrl.getAddonsWithVenueSportListUrl}`;
    try{
        const response = await axios.post(url, {
            sport_id: sportId,
            venue_id: venueId
        });
        return response.data
    }catch(err){
        console.log(err);
        return err?.response?.data
    }
}

export const socialMediaHandles = async () => {
    const url = `${ApiBaseURL}${configURL.socialMediaUrl}`;
    
    try{
      const response = await uaxios.get(url)
      return response?.data?.data
    }
    catch (error) {
      console.log("error : ", error);
      return null;
    }
  }

export const downloadInvoice = async (bookingId, fileRefName) => {
    try {
        const response = await axios.post(
            `${ApiBaseURL}${configURL.downloadInvoiceUrl}`,
            { booking_id: bookingId },
            {
                responseType: "blob", // Important: Ensures the response is treated as a file
            }
        );

        // ✅ Create a blob from the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // ✅ Create a URL for the blob
        const url = window.URL.createObjectURL(blob);

        // ✅ Create a temporary <a> tag to trigger download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `booking_${fileRefName}.pdf`); // File name
        document.body.appendChild(link);
        link.click(); // Auto-click to trigger download

        // ✅ Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Free up memory
        alert("Invoice downloaded successfully.");
    } catch (error) {
        console.error("Error downloading the invoice:", error);
        alert("Failed to download invoice. Please try again.");
    }
};